import {FrontendPage} from "../FrontendPage";
import {$, moment} from "../Application";

export class BasePage extends FrontendPage {
    runOnCurrentPage(): boolean {
        return true;
    }

    onReady() {
        moment.updateLocale('de', {
            week: {
                dow: 1,
                doy: 7
            } // Monday is the first day of the week
        });

        $('.select-all').on('click', function () {
            let $select2 = $(this).parent().siblings('.select2')
            $select2.find('option').prop('selected', 'selected')
            $select2.trigger('change')
        });
        $('.deselect-all').on('click', function () {
            let $select2 = $(this).parent().siblings('.select2')
            $select2.find('option').prop('selected', '')
            $select2.trigger('change')
        });

        // @ts-ignore
        $('.select2').select2();

        $('.treeview').each(function () {
            var shouldExpand = false
            $(this).find('li').each(function () {
                if ($(this).hasClass('active')) {
                    shouldExpand = true
                }
            })
            if (shouldExpand) {
                $(this).addClass('active')
            }
        });
    }
}
